import { Directive } from '@angular/core';
import { NG_VALIDATORS, FormControl } from '@angular/forms';
import * as moment from 'moment';

export function discountValidator(control: FormControl) {
    let discount = parseInt(control.value);
    
    if (discount) {
        var maxDiscount = 25;
        if(discount>maxDiscount){

            return {
                invalidDiscount : true
            }
   
        }        
     }
    return null;
}

@Directive({
    selector: '[discountValidator][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useValue: discountValidator,
            multi: true
        }
    ]
})
export class DiscountValidator {
}